export const ApplicationRight = {
  
  // New Access
  Member_Access: '用户管理',//User Management
  Payment_Access: '收款管理',//Payment Management
  Magazine_Access: '杂志管理',//Magazine Management
  News_Posts_Access: '资讯管理',//New Management
  Promotion_Access: '促销管理',//Promotion Management
  Staff_Management_Access: '账户管理',//Staff Management
  System_Setting_Access: 'System_Setting_Access',
  Education_Management_Access: '教育管理',
  Course_Purchase_Access: '课程购买',//Course Purchase
  Product_Purchase_Access: '产品购买',//Product Purchase
  Product_Management_Access: '产品管理',//Product Management
  Ads_Settings_Access: '广告设置',//Ads Settings
  Featured_Works_Access: '主题作品',//Featured Works
  Featured_Works_Sub_Access: '男/女/前卫创意',//Men's / Women's / Avant-Garde Creativity
  Technology_Display_Access: '技术展示',//Technology Display
  Banner_Management_Access: '横幅',//Banner Management,
  Coupon_Management_Access:"代惠券管理" // Coupon Management
};
 